module.exports = __webpack_public_path__ + "static/media/jacksonville-catering-2.15cde20f.jpg";